import { render, staticRenderFns } from "./imgVideo.vue?vue&type=template&id=4dc9d156"
import script from "./imgVideo.vue?vue&type=script&lang=js"
export * from "./imgVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports